module.exports = __webpack_public_path__ + "static/media/AML-Penalties-v2.98bb75f4.svg";